module.exports = {
      id: "blockquote-usage",
      viewBox: "0 0 43 36",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#blockquote",
      toString: function () {
        return this.url;
      }
    }